import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss";
import {FormattedMessage} from "react-intl";
import {BigButton} from "../../../../components/button";
import React, {useState} from "react";
import CheckoutConfirm from "../../../shoppingcart/pages/bag/fragments/checkout-confirm";
import {useLogin} from "../../../../hooks/common";
import {SensorsTrack} from "../../../../utils/sensor";
import {TOGGLE_UI_LOGIN} from "../../../../../store/actions/ui";
import {useDispatch} from "react-redux";

export default props =>{
    useStyles(classes);
    const {quickBuyBtnHandle}=props
    const [showCheckoutConfirm, setShowCheckoutConfirm] = useState(false)
    const isLogin = useLogin()
    const dispatch = useDispatch()
    const handleClick=()=>{
        SensorsTrack('QUICK_BUY_BTN_CLICK', {  })
        if(isLogin){
            quickBuyBtnHandle()
        }else{
            setShowCheckoutConfirm(true)
        }
    }
    const guestHandle = async () =>{
        SensorsTrack('QUICK_BUY_GUEST_BTN_CLICK', {  })
        setShowCheckoutConfirm(false)
        quickBuyBtnHandle()
    }
    const continueHandle = () => {
        SensorsTrack('QUICK_BUY_CONTINUE_BTN_CLICK', {  })
        dispatch({
            type: TOGGLE_UI_LOGIN,
            payload: {
                showLogin: true,
                eventType: "购买中",
                callBack: async () => {
                    setShowCheckoutConfirm(false)
                    quickBuyBtnHandle()
                }
            }
        })
    }
    return  <React.Fragment>
        <BigButton
            className={classes.Buy}
            onClick={handleClick}
        >
            <FormattedMessage id="buy" defaultMessage="BUY" />
        </BigButton>
        <CheckoutConfirm onGuest={guestHandle} onContinue={continueHandle} show={showCheckoutConfirm} onClose={e => setShowCheckoutConfirm(false)} />

    </React.Fragment>
}